import { ComponentProps } from "react";
import * as S from "./styles";
interface IInputRadioProps extends ComponentProps<"input"> {
  label: string;
}

export const InputRadio = ({ label, ...rest }: IInputRadioProps) => {
  return (
    <S.InputRadioContainerStyle>
      <input {...rest} type="radio" />
      <span>{label}</span>
      <S.WrapperImg>
        {rest.checked ? (
          <S.imgChecked src="/assets/svg/check-outlined.svg" alt="checked" />
        ) : (
          <S.imgUnchecked
            src="/assets/svg/unchecked-outlined.svg"
            alt="unchecked"
          />
        )}
      </S.WrapperImg>
    </S.InputRadioContainerStyle>
  );
};
